import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let PackageService = class PackageService {
    constructor(api) {
        this.api = api;
        // #region Package Quota Distribution
        this.findPackageLimit = this.api.findPackageLimit;
        this.savePackageLimit = this.api.savePackageLimit;
    }
    async getProducts() {
        const res = await this.api.getProductsApi();
        return res.data;
    }
    async getPackages() {
        const res = await this.api.getPackagesApi();
        return res.data;
    }
    savePackage(data) {
        return this.api.savePackageApi(data);
    }
};
PackageService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApi)),
    __metadata("design:paramtypes", [Object])
], PackageService);
export { PackageService };
